import { immerable } from 'immer'

export class ArticleIndex {
    [immerable] = true

    systemN: number
    system: number
    group: number
    article: number

    // article = -1 for article group
    constructor(systemN: number, system: number, group: number, article: number) {
        this.systemN = systemN
        this.system = system
        this.group = group
        this.article = article
    }
}
